import _ from 'lodash';

export const isBootstraped = (state) => (_.get(state, 'app.bootstraped'));
export const getServerAlias = (state) => (_.get(state, 'app.serverAlias'));
